import React from 'react';
import {Link} from 'react-router-dom';
import {Card} from '@shopify/polaris';
import {
  Routes,
  fetchTaxonomy,
} from 'sections/services-marketplace/experts/utilities';
import {LinkLikeText} from 'sections/services-marketplace/components';

import styles from './ParentCategories.scss';

export default function ParentServiceGroups() {
  const taxonomy = fetchTaxonomy().taxonomy;
  return (
    <div className={styles.CollectionGrid}>
      {taxonomy.map(parentCategory => (
        <div key={parentCategory.service.handle}>
          <CardContainer
            handle={parentCategory.service.handle}
            label={parentCategory.service.shortLabel}
          />
        </div>
      ))}
    </div>
  );
}

function CardContainer({handle, label}: {handle: string; label: string}) {
  const taxonomy = fetchTaxonomy();

  return (
    <div className={styles.CardContainer}>
      <Link to={Routes.servicePath(taxonomy, handle)}>
        <Card>
          <div className={styles.CardContent}>
            <img
              src={Routes.imagePath(`svg/${handle}.svg`)}
              alt=""
              className={styles.CardImage}
            />
            <LinkLikeText monochrome>{label}</LinkLikeText>
          </div>
        </Card>
      </Link>
    </div>
  );
}
